export const getAdsStepStyles = (/* components, theme */) => ({
  videoPanelRoot: {
    marginTop: 20,
    width: 500,
    minHeight: 181,
    padding: 20,
    paddingBottom: 20,
    paddingTop: 10,
    background: '#FFFFFF',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    borderRadius: 6,
    '& .image-list-item-status-indicator': {
      background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%)',
      borderRadius: 6,
      width: '170px !important',
      height: '96px !important',
      paddingTop: '10px !important',
      '&:hover': {
        '& .edit-button': {
          display: 'none',
        },
      },
      '& .placeholder-content': {
        color: 'white !important',
      },
    },
    '& .error': {
      marginTop: 20,
    },
    '& .image-experience-content': {
      width: 170,
      '& .col-sm-3': {
        background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%)',
        borderRadius: 6,
        width: '170px !important',
        height: '96px !important',
        paddingTop: '10px !important',
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column',
        alignItems: 'center',
        '&:hover': {
          '& .edit-button': {
            display: 'none',
          },
        },
        '& .placeholder-content': {
          color: 'white !important',
        },
        '& .ms-Button': {
          width: 56,
          height: 24,
          marginTop: 10,
        },
      },
      '& .add-image-button': {
        border: '1px solid #8a8886',
        background: '#FFFFFF !important',
        fontWeight: 600,
        borderRadius: 2,
        '&:before': {
          content: '"\\E710"',
          color: '#0078D4',
          marginRight: 8,
          fontFamily: 'MsAds MDL2 Assets',
        },
      },
    },
    '& .image-section-label': {
      display: 'flex',
      alignItems: 'center',
    },
    '& .image-list-label': {
      fontWeight: 600,
    },
    '& .image-list-content': {
      width: '170px !important', // fixed for 16:9 aspect ratio
      border: 'none !important',
      padding: '0px !important',
    },
    '& .image-list-item-video': {
      position: 'relative',
      backgroundColor: 'none !important',
      width: '170px !important', // fixed for 16:9 aspect ratio
      '&:hover': {
        '& .edit-button': {
          display: 'flex',
        },
      },
      '& .placeholder-content': {
        color: 'black !important',
      },

    },
    '& .image-item-ratio-label': {
      paddingTop: 10,
    },
    '& .thumbnail-preview': {
      borderRadius: 6,
      filter: 'drop-shadow(0px 0.6px 1.8px rgba(0, 0, 0, 0.1)) drop-shadow(0px 3.2px 7.2px rgba(0, 0, 0, 0.13))',
      width: '170px !important',
      height: '96px !important',
    },
  },
  videoRepairPanelRoot: {
    marginTop: 20,
    width: 800,
    minHeight: 181,
    padding: 20,
    paddingBottom: 20,
    paddingTop: 10,
    background: '#FFFFFF',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    borderRadius: 6,
    '& .image-list-item-status-indicator': {
      background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%)',
      borderRadius: 6,
      width: '170px !important',
      height: '96px !important',
      paddingTop: '10px !important',
      '&:hover': {
        '& .edit-button': {
          display: 'none',
        },
      },
      '& .placeholder-content': {
        color: 'white !important',
      },
    },
    '& .error': {
      marginTop: 20,
    },
    '& .image-experience-content': {
      width: 170,
      '& .col-sm-3': {
        background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%)',
        borderRadius: 6,
        width: '170px !important',
        height: '96px !important',
        paddingTop: '10px !important',
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column',
        alignItems: 'center',
        '&:hover': {
          '& .edit-button': {
            display: 'none',
          },
        },
        '& .placeholder-content': {
          color: 'white !important',
        },
        '& .ms-Button': {
          width: 56,
          height: 24,
          marginTop: 10,
        },
      },
      '& .add-image-button': {
        border: '1px solid #8a8886',
        background: '#FFFFFF !important',
        fontWeight: 600,
        borderRadius: 2,
        '&:before': {
          content: '"\\E710"',
          color: '#0078D4',
          marginRight: 8,
          fontFamily: 'MsAds MDL2 Assets',
        },
      },
    },
    '& .image-section-label': {
      display: 'flex',
      alignItems: 'center',
    },
    '& .image-list-label': {
      fontWeight: 600,
    },
    '& .image-list-content': {
      width: '170px !important', // fixed for 16:9 aspect ratio
      border: 'none !important',
      padding: '0px !important',
    },
    '& .image-list-item-video': {
      position: 'relative',
      backgroundColor: 'none !important',
      width: '170px !important', // fixed for 16:9 aspect ratio
      '&:hover': {
        '& .edit-button': {
          display: 'flex',
        },
      },
      '& .placeholder-content': {
        color: 'black !important',
      },

    },
    '& .image-item-ratio-label': {
      paddingTop: 10,
    },
    '& .thumbnail-preview': {
      borderRadius: 6,
      filter: 'drop-shadow(0px 0.6px 1.8px rgba(0, 0, 0, 0.1)) drop-shadow(0px 3.2px 7.2px rgba(0, 0, 0, 0.13))',
      width: '170px !important',
      height: '96px !important',
    },
  },
  selectedPanel: {
    border: '1px solid #0078D4',
  },
  videoPanelHeader: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
    height: 5,
  },
  adPreviewTitle: {
    fontSize: 18,
    fontWeight: 600,
  },
  previewContainer: {
    width: '100%',
  },
  adPreviewHeader: {
    height: 40,
  },
  adPreviewRoot: {
    maxWidth: '540px',
    width: '100%',
    padding: 20,
    paddingBottom: 20,
    position: 'sticky',
    top: '0px',
    display: 'flex',
    flexWrap: 'wrap',
  },
  video: {
    borderRadius: '6px',
    filter: 'drop-shadow(0px 0.6px 1.8px rgba(0, 0, 0, 0.1)) drop-shadow(0px 3.2px 7.2px rgba(0, 0, 0, 0.13))',
  },
  previewTag: {
    marginTop: 10,
  },
  pagination: {
    paddingTop: 10,
    width: '100%',
  },
  pageControls: {
    display: 'flex',
    alignItems: 'center',
    columnGap: '10px',
  },
  paginationIndicatorDot: {
    height: 8,
    width: 8,
    borderRadius: '50%',
    display: 'inline-block',
    cursor: 'pointer',
  },
  paginationButton: {
    height: 8,
    width: 8,
    opacity: 0,
  },
  paginationIndicator: {
    display: 'flex',
    columnGap: '2px',
  },
  videoPanelContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  placementInfoTile: {
    paddingTop: 20,
    marginLeft: 10,
  },
  placementInfos: {
    display: 'flex',
    flexWrap: 'wrap',
    columnGap: 10,
    rowGap: '5px',
    alignItems: 'center',
  },
  enabledPlacement: {
    backgroundColor: '#DFF6DD',
    padding: '3px 5px',
    borderRadius: 4,
  },
  enabledText: {
    color: '#0C5E0C',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    columnGap: 5,
  },
  disabledPlacement: {
    backgroundColor: '#F3F2F1',
    padding: '3px 5px',
    borderRadius: 4,
  },
  disabledText: {
    color: '#605E5C',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    columnGap: 5,
  },
  fontStyle: {
    fontSize: 14,
    fontWeight: 600,
  },
  placementLabel: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  placmentResolution: {
    paddingTop: 5,
    paddingBottom: 5,
  },
  videoPanelFinalUrlContainer: {
    width: 45,
  },
  starStyle: {
    fontSize: 20,
  },
});

export const getImageSuggestionCarouselStyles = () => ({
  imageSuggestionCarouselRoot: {
    '& .image-suggestion-carousel-root': {
      '& .panel': {
        backgroundColor: 'transparent',

        '& .helpbutton': {
          margin: '4px 0px',
        },
      },
    },
    marginTop: 10,
  },
  croppedImage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '107px',
    height: '76px',
    background: '#F3F2F1',
  },
});
